import debounce from 'lodash/debounce';
import toggleClasses from './classes-toggle';

const getHeadingList = () => {
  const allHeadings = document.querySelectorAll('.twoyou-heading.has-all-colors');
  return allHeadings;
};

const originalHeadings = Array.from(getHeadingList()).map(heading =>
  Array.from(heading.children[0].classList),
);

const changeableHeadings = getHeadingList();

const handleHeadingClasses = debounce(() => {
  const windowWidth = window.innerWidth;

  const mobilePrefix = 'u--mobileText-';
  const tabletPrefix = 'u--tabletText-';
  const desktopPrefix = 'u--text';

  changeableHeadings.forEach((h, index) => {
    const headingTag = h.querySelector('h1,h2,h3,h4,h5,h6');
    headingTag.className = '';
    headingTag.className = originalHeadings[index].join(' ');

    if (windowWidth < 760) {
      if (headingTag.className.includes(mobilePrefix)) {
        toggleClasses([tabletPrefix, desktopPrefix], headingTag);
      }
      if (!headingTag.className.includes(mobilePrefix)) {
        toggleClasses([desktopPrefix], headingTag);
      }
    }

    if (windowWidth >= 760 && windowWidth < 1024) {
      if (headingTag.className.includes(tabletPrefix)) {
        toggleClasses([mobilePrefix, desktopPrefix], headingTag);
      }
    }

    if (windowWidth >= 1024) {
      toggleClasses([mobilePrefix, tabletPrefix], headingTag);
    }
  });
}, 250);

if (changeableHeadings.length !== 0) {
  window.addEventListener('DOMContentLoaded', handleHeadingClasses, false);
  window.addEventListener('resize', handleHeadingClasses, false);
}
